export interface TemplateMapping {
    titleSelector?: string;
    descSelector?: string;
    priceSelector?: string;
    oldPriceSelector?: string;
    primaryColorVar: string;
    secondaryColorVar?: string;
    logoSelector?: string;
    coverSelector?: string;
    avatarSelector?: string;
    handleSelector?: string;
    badgeSelector?: string;
    bannerSubSelector?: string;
    footerSecSelector?: string;
    pixTitleSelector?: string;
    pixDescSelector?: string;
    inputNamePlaceholder?: string;
    inputCpfPlaceholder?: string;
    notificationTitleSelector?: string;
    cardBadgeSelector?: string;
    timerLabelSelector?: string;
    socialSelectors?: { [key: string]: string };
    plansSelectors?: {
        plan1: { container?: string; name: string; price: string; link: string; };
        plan2: { container?: string; name: string; price: string; link: string; };
        plan3: { container?: string; name: string; price: string; link: string; };
    };
    bioSelector?: string;
    readMoreSelector?: string;
}

export interface Template {
    id: string;
    name: string;
    description: string;
    basePath: string;
    tag: string;
    files: { html: string; css: string; };
    mapping: TemplateMapping;
}

export interface CustomConfig {
    texts: {
        title: string;
        subtitle: string;
        price: string;
        oldPrice: string;
        handle: string;
        ctaButton: string;
        footerNote: string;
        pixTitle: string;
        pixDesc: string;
        cardBadgeText: string;
        namePlaceholder: string;
        cpfPlaceholder: string;
        notifTitle: string;
    };
    styling: {
        primaryColor: string;
        secondaryColor: string;
        accentColor: string;
        ctaColor: string;
        borderRadius: string;
    };
    media: {
        logo: string;
        cover: string;
        avatar: string;
        carousel: string[];
    };
    links: { [key: string]: string };
    features: {
        showTimer: boolean;
        showNotifications: boolean;
        showSocial: boolean;
        showBadges: boolean;
        notificationMode: 'random' | 'manual';
        manualNames: string[];
        notificationCount: number;
        timerMinutes: number;
        notificationStyling: {
            bgColor: string;
            textColor: string;
            iconColor: string;
            msgTemplate: string;
        };
    };
    plans: {
        plan1: { name: string; price: string; link: string; };
        plan2: { name: string; price: string; link: string; };
        plan3: { name: string; price: string; link: string; };
    };
    socialVisibility: {
        instagram: boolean;
        tiktok: boolean;
    };
    slug?: string;
    subdomain?: string;
}

export const templates: Template[] = [
    {
        id: '01',
        name: 'Classic Pro Checkout',
        description: 'Design focado em conversão com suporte a carrossel de imagens e prova social.',
        basePath: '/templates/larissa/',
        tag: 'Especialista',
        files: { html: 'index.html', css: 'style.css' },
        mapping: {
            timerLabelSelector: '.timer-label',
            descSelector: '.lifetime-badge',
            priceSelector: '.new-price',
            oldPriceSelector: '.old-price',
            primaryColorVar: '--neon-green',
            secondaryColorVar: '--dark-bg',
            logoSelector: '.footer-seal-img',
            badgeSelector: '.lifetime-badge',
            bannerSubSelector: '.price-banner div',
            footerSecSelector: '.sec-label span',
            pixTitleSelector: '.pix-header span',
            pixDescSelector: '.pix-desc',
            inputNamePlaceholder: '#input-name',
            inputCpfPlaceholder: '#input-cpf',
            notificationTitleSelector: '.notif-title',
            cardBadgeSelector: '.card-badge',
            socialSelectors: {
                telegram: '.social-links a[href*="t.me"]',
                tiktok: '.social-links a[href*="tiktok"]'
            }
        }
    },
    {
        id: '02',
        name: 'Privacy Pro Checkout',
        description: 'Template moderno estilo OnlyFans com perfil de criador e assinaturas.',
        basePath: '/templates/viih/',
        tag: 'Premium',
        files: { html: 'index.html', css: '_next/static/chunks/8af34fe34febe279.css' },
        mapping: {
            titleSelector: 'h2.text-2xl.font-bold, p.font-semibold.text-sm.text-black',
            descSelector: 'p.text-gray-800',
            handleSelector: 'p.text-gray-500',
            priceSelector: 'span.text-lg.font-extrabold',
            primaryColorVar: '--primary-color',
            secondaryColorVar: '--bg-color',
            logoSelector: 'img[alt="privacy"]',
            coverSelector: '#main-cover',
            avatarSelector: '#main-avatar',
            bioSelector: '.text-gray-800 p',
            readMoreSelector: 'button.text-\\[\\#FF8C5A\\]',
            plansSelectors: {
                plan1: {
                    container: '',
                    name: 'a[class*="bg-gradient-to-r"][data-slot="button"] span:nth-of-type(1)',
                    price: 'a[class*="bg-gradient-to-r"][data-slot="button"] span:nth-of-type(2)',
                    link: 'a[class*="bg-gradient-to-r"][data-slot="button"]'
                },
                plan2: {
                    container: '',
                    name: '.space-y-3 a[data-slot="button"]:nth-of-type(1) span:nth-of-type(1)',
                    price: '.space-y-3 a[data-slot="button"]:nth-of-type(1) span:nth-of-type(2)',
                    link: '.space-y-3 a[data-slot="button"]:nth-of-type(1)'
                },
                plan3: {
                    container: '',
                    name: '.space-y-3 a[data-slot="button"]:nth-of-type(2) span:nth-of-type(1)',
                    price: '.space-y-3 a[data-slot="button"]:nth-of-type(2) span:nth-of-type(2)',
                    link: '.space-y-3 a[data-slot="button"]:nth-of-type(2)'
                }
            },
            socialSelectors: {
                instagram: 'a[href*="instagram"]',
                tiktok: 'a[href*="tiktok"]'
            }
        }
    }
];

export const applyTemplateConfig = (doc: Document, template: Template, config: CustomConfig) => {
    if (!doc || !template) return;

    const setTxt = (sel: string | undefined, val: string) => { if (sel) { const el = doc.querySelectorAll(sel); el.forEach(e => e.textContent = val); } };
    const setPlaceholder = (sel: string | undefined, val: string) => { if (sel) { const el = doc.querySelector(sel) as HTMLInputElement; if (el) el.placeholder = val; } };
    const setImg = (sel: string | undefined, val: string) => { if (sel && val) { const el = doc.querySelector(sel) as HTMLImageElement; if (el) el.src = val; } };
    const toggle = (sel: string | undefined, show: boolean) => { if (sel) { const el = doc.querySelector(sel) as HTMLElement; if (el) el.style.display = show ? '' : 'none'; } };

    // 1. Textos Universais
    setTxt(template.mapping.titleSelector, config.texts.title);
    setTxt(template.mapping.handleSelector, config.texts.handle);
    setTxt(template.mapping.descSelector, config.texts.subtitle);
    setTxt(template.mapping.priceSelector, config.texts.price);
    setTxt(template.mapping.oldPriceSelector, config.texts.oldPrice);
    setTxt(template.mapping.timerLabelSelector, config.texts.title);

    // 2. Textos de Identidade
    setTxt(template.mapping.badgeSelector, config.texts.subtitle);
    setTxt(template.mapping.bannerSubSelector, config.texts.footerNote);
    setTxt(template.mapping.footerSecSelector, config.texts.ctaButton === 'PAGAR AGORA' ? 'COMPRA 100% SEGURA' : 'CHECKOUT SEGURO');
    setTxt(template.mapping.pixTitleSelector, config.texts.pixTitle);
    setTxt(template.mapping.pixDescSelector, config.texts.pixDesc);
    setTxt(template.mapping.notificationTitleSelector, config.texts.notifTitle);
    setTxt(template.mapping.cardBadgeSelector, config.texts.cardBadgeText);

    // 3. Form & Placeholders
    setPlaceholder(template.mapping.inputNamePlaceholder, config.texts.namePlaceholder);
    setPlaceholder(template.mapping.inputCpfPlaceholder, config.texts.cpfPlaceholder);
    setTxt('.submit-btn', config.texts.ctaButton);

    // 4. Mídia
    if (config.media.logo && template.mapping.logoSelector) {
        setImg(template.mapping.logoSelector, config.media.logo);
    }

    // Específico para Template VIIH (02)
    if (template.id === '02') {
        if (template.mapping.coverSelector) {
            const coverEl = doc.querySelector(template.mapping.coverSelector) as HTMLImageElement;
            if (coverEl) {
                if (!coverEl.getAttribute('data-original-src')) coverEl.setAttribute('data-original-src', coverEl.src);
                if (config.media.cover) {
                    coverEl.src = config.media.cover;
                    coverEl.style.display = 'block';
                } else {
                    const original = coverEl.getAttribute('data-original-src');
                    if (original) coverEl.src = original;
                }
            }
        }

        if (template.mapping.avatarSelector) {
            const avatarEls = doc.querySelectorAll(template.mapping.avatarSelector);
            avatarEls.forEach(el => {
                if (el instanceof HTMLImageElement) {
                    if (!el.getAttribute('data-original-src')) el.setAttribute('data-original-src', el.src);
                    if (config.media.avatar) {
                        el.src = config.media.avatar;
                        el.style.display = 'block';
                    } else {
                        const original = el.getAttribute('data-original-src');
                        if (original) el.src = original;
                    }
                }
            });

            const avatarSpans = doc.querySelectorAll('span[data-slot="avatar"]');
            avatarSpans.forEach(span => {
                let img = span.querySelector('img');
                if (config.media.avatar) {
                    if (!img) {
                        img = doc.createElement('img');
                        img.className = 'w-full h-full object-cover';
                        img.alt = 'Avatar';
                        span.innerHTML = '';
                        span.appendChild(img);
                    }
                    img.src = config.media.avatar;
                }
            });
        }

        if (template.mapping.bioSelector) {
            setTxt(template.mapping.bioSelector, config.texts.subtitle);
            if (template.mapping.readMoreSelector) {
                const readMoreBtn = doc.querySelector(template.mapping.readMoreSelector) as HTMLElement;
                if (readMoreBtn) readMoreBtn.style.display = 'none';
            }
        }

        const updatePlan = (planKey: 'plan1' | 'plan2' | 'plan3', planConfig: { name: string, price: string, link: string }) => {
            const selector = template.mapping.plansSelectors?.[planKey];
            if (selector) {
                setTxt(selector.name, planConfig.name);
                setTxt(selector.price, planConfig.price);
                const linkEl = doc.querySelector(selector.link) as HTMLAnchorElement;
                if (linkEl) {
                    linkEl.removeAttribute('href');
                    linkEl.removeAttribute('target');
                    linkEl.style.cursor = 'pointer';
                    linkEl.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        window.parent.postMessage({
                            type: 'hotlize-plan-selected',
                            plan: planKey,
                            name: planConfig.name,
                            price: planConfig.price,
                            link: planConfig.link || ''
                        }, '*');
                    });
                }
            }
        };

        updatePlan('plan1', config.plans.plan1);
        updatePlan('plan2', config.plans.plan2);
        updatePlan('plan3', config.plans.plan3);

        if (template.mapping.socialSelectors) {
            const setSoc = (sel: string | undefined, vis: boolean) => {
                if (sel) {
                    const el = doc.querySelector(sel) as HTMLElement;
                    if (el) el.style.display = vis ? 'flex' : 'none';
                }
            };
            setSoc(template.mapping.socialSelectors.instagram, config.socialVisibility.instagram);
            setSoc(template.mapping.socialSelectors.tiktok, config.socialVisibility.tiktok);
        }
    }

    // 5. Visibilidade Geral
    toggle('.sticky-header', config.features.showTimer);
    toggle('.social-links', config.features.showSocial);
    toggle('.lifetime-badge', config.features.showBadges);

    // 6. Estilos Dinâmicos
    let styleTag = doc.getElementById('dynamic-styles');
    if (!styleTag) {
        styleTag = doc.createElement('style');
        styleTag.id = 'dynamic-styles';
        doc.head.appendChild(styleTag);
    }
    styleTag.textContent = `
            :root { 
                ${template.mapping.primaryColorVar}: ${config.styling.primaryColor} !important;
                ${template.mapping.secondaryColorVar || '--dark-bg'}: ${config.styling.secondaryColor} !important;
            }
            * { margin-top: 0 !important; }
            .container { padding-top: 10px !important; }
            body { background-color: ${config.styling.secondaryColor} !important; }
            
            .price-banner, .price-section { background: ${config.styling.primaryColor} !important; }
            .lifetime-badge { background-color: ${config.styling.primaryColor} !important; }

            .submit-btn { 
                background: ${config.styling.ctaColor} !important; 
                box-shadow: 0 4px 15px ${config.styling.ctaColor}66 !important;
                border-radius: ${config.styling.borderRadius} !important; 
            }
             input[type="text"] { border-radius: ${config.styling.borderRadius} !important; }
    `;

    // 7. Carrossel
    if (config.media.carousel.length > 0) {
        const track = doc.querySelector('.carousel-track');
        if (track) {
            track.innerHTML = '';
            config.media.carousel.forEach(imgSrc => {
                const card = doc.createElement('div');
                card.className = 'carousel-card';
                const img = doc.createElement('img');
                img.src = imgSrc;
                card.appendChild(img);
                track.appendChild(card);
            });
        }
    }

    // 8. Notifications e Timer
    const notifContainer = doc.getElementById('notification-container');
    if (notifContainer) {
        notifContainer.style.display = config.features.showNotifications ? 'flex' : 'none';
        let notifStyle = doc.getElementById('notif-custom-styles');
        if (!notifStyle) {
            notifStyle = doc.createElement('style');
            notifStyle.id = 'notif-custom-styles';
            doc.head.appendChild(notifStyle);
        }
        let css = '';
        const { bgColor, textColor, iconColor } = config.features.notificationStyling;
        if (bgColor) css += `.sales-notification { background: ${bgColor} !important; }`;
        if (textColor) css += `.notif-title, .notif-msg, .notif-time { color: ${textColor} !important; }`;
        if (iconColor) css += `.notif-icon i { color: ${iconColor} !important; } .sales-notification { border-left: 4px solid ${iconColor} !important; }`;
        notifStyle.textContent = css;
    }
};
